module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("I dedicate this book to")]), _vm._v(" single "), _c('em', [_vm._v("mothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("You are the nameless celebrity and seldom glorified superstar. Your fan base is limited to the number of offspring you bore. Your fame is overshadowed by anonymity. You carry the blistering sun on your shoulders in the daytime, and withstand the pressure of its descent on your soul in the night. You endure sleepless nights and dreamless days, sacrificing that which nurtures what you know can become. And though human in your struggle, you pull it off with the grace of eagles and brilliance of all that is regal.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I am an eyewitness to your struggle and to your courage.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I am in awe of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I offer you a standing ovation.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I applaud you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I am one of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("And I dedicate this book, in its entirety, to you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0